<!-- 选择工作类型面板 -->
<template>
    <panel-down :panelTitle="'选择工作类型'" :isShowCont="isShowCont"
    @surePanel="surePanel" @closePanel="closePanel">
        <ul class="pub-worktype-wrap" v-if="isMultiSelect">
            <li class="worktype-item" :class="{'selected': item.selected}" 
            @click="chgSelected(index)" v-for="(item,index) in list" :key="item.id" v-if="!excludeId || item.id != excludeId">
                <img :src="item.imageUrl">
                <img class="selected-mark" src="../../assets/images/i_complete.png">
            </li>
        </ul>
        <ul class="pub-worktype-wrap" v-else>
            <li class="worktype-item" :class="{'selected': item.id == cacheSelectedWorktype.id}" 
            @click="chgSelected(index)" v-for="(item,index) in list" :key="item.id" v-if="!excludeId || item.id != excludeId">
                <img :src="item.imageUrl">
                <img class="selected-mark" src="../../assets/images/i_complete.png">
            </li>
        </ul>
    </panel-down>
</template>
<script>
export default {
    props: {
        curWorktype: { //当前选中项 - 单选
            type: Object
        },
        isMultiSelect: { //是否多选
            type: Boolean,
            default: false
        },
        curWorktypeList: { //当前选中项 - 多选
            type: Array
        },
        excludeId: { //排除的选项
            type: Number,
            default: 1
        },
    },
	data () {
		return {
            isShowCont: true,
            list: [
                {
                    id: 1,
                    Key: 1,
                    Value: "TemporaryHourLabour",
                    categoryName: "临时保洁",
                    imageUrl: require("../../assets/images/worktype/channel_search_item_01.png"),
                    selected: false,
                },
                {
                    id: 2,
                    Key: 2,
                    Value: "MonthHourLabour",
                    categoryName: "长期钟点工",
                    imageUrl: require("../../assets/images/worktype/channel_search_item_02.png"),
                    selected: false,
                },
                {
                    id: 6,
                    Key: 6,
                    Value: "InfantCare",
                    categoryName: "育婴师服务",
                    imageUrl: require("../../assets/images/worktype/channel_search_item_03.png"),
                    selected: false,
                },
                // {
                //     id: 4,
                //     categoryName: "保姆",
                //     imageUrl: require("../../assets/images/worktype/channel_search_item_01.png"),
                // },
                {
                    id: 4,
                    Key: 4,
                    Value: "LiveInCaregiver",
                    categoryName: "住家保姆",
                    imageUrl: require("../../assets/images/worktype/channel_search_item_04.png"),
                    selected: false,
                },
                {
                    id: 5,
                    Key: 5,
                    Value: "ConfinementNurse",
                    categoryName: "月嫂服务",
                    imageUrl: require("../../assets/images/worktype/channel_search_item_05.png"),
                    selected: false,
                },
                {
                    id: 3,
                    Key: 3,
                    Value: "WorkdaysNanny",
                    categoryName: "全天保姆",
                    imageUrl: require("../../assets/images/worktype/channel_search_item_06.png"),
                    selected: false,
                },
                // {
                //     id: 99,
                //     categoryName: "自营",
                // },
            ],
            cacheSelectedWorktype: {},
            cacheSelectedWorktypeList: [],
		}
    },
    mounted(){
        this.init();
    },
	methods: {
        //初始化
        init(){
            let self = this;
            self.cacheSelectedWorktype = self.curWorktype ? JSON.parse(JSON.stringify(self.curWorktype)) : {};
            self.cacheSelectedWorktypeList = self.curWorktypeList ? JSON.parse(JSON.stringify(self.curWorktypeList)) : [];
            if(self.isMultiSelect && self.cacheSelectedWorktypeList && self.cacheSelectedWorktypeList.length>0){
                self.cacheSelectedWorktypeList.map((item,index) => {
                    for(let i=0; i<self.list.length; i++){
                        if(self.list[i].Key == item.Key){
                            let newItem = JSON.parse(JSON.stringify(self.list[i]));
                            newItem.selected = true;
                            self.list.splice(i,1,newItem);
                            break;
                        }
                    }
                });
            }
        },
        //修改选中
        chgSelected(paramsIndex){
            let self = this;
            if(self.isMultiSelect){
                self.list[paramsIndex].selected = !self.list[paramsIndex].selected;
            } else {
                self.cacheSelectedWorktype.id = self.list[paramsIndex].id;
                self.cacheSelectedWorktype.value = self.list[paramsIndex].categoryName;
            }
        },
        //确定
        surePanel(){
            if(this.isMultiSelect){
                this.$emit("surePanel",this.list);
            } else {
                this.$emit("surePanel",this.cacheSelectedWorktype);
            }
            this.closePanel();
        },
        //取消
        closePanel() {
            this.isShowCont = false;
            let delayClosePanel = setTimeout(() => {
                this.$emit("closePanel");
            }, 500);
        },
	}
}
</script>
<style>
.pub-worktype-wrap{
    width: 78%;
    margin: 0 auto 0.4rem;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    flex-wrap: wrap;
}
.pub-worktype-wrap .worktype-item {
    flex: 0 0 auto;
    width: 33.3%;
    margin-top: 0.5rem;
    position: relative;
    transition: all 0.5s ease;
}
.pub-worktype-wrap .worktype-item .selected-mark{
    width: 0.6rem;
    position: absolute;
    right: -0.06rem;
    top: 0;
    z-index: 9;
    opacity: 0;
    transition: all 0.5s ease;
}
.pub-worktype-wrap .worktype-item.selected .selected-mark{
    opacity: 1;
}

.pub-worktype-wrap .worktype-item:after {
    content: "";
    width: 1px;
    height: 94%;
    display: block;
    background-color: #cccccc;
    position: absolute;
    right: 0;
    bottom: 0;
}

.pub-worktype-wrap .worktype-item:nth-child(3n):after,
.pub-worktype-wrap .worktype-item:last-child:after {
    display: none;
}
</style>


// WEBPACK FOOTER //
// src/shared/components/job/worktype-panel.vue